import { ROLE } from './baseUrls';

export const GET_STUDENT_SIBILING = (StudentId) => `${ROLE}/student/${StudentId}/getsibling`;

